import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "isActive", "color", "size", "strokeWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * This is a utility function that is used for creating a HOC that
 * is used for mapping React props to bootstrap classes. This way we can
 * control the different attributes of our SVG icons with utility classes
 * instead of mapping properties onto the SVG component.
 */
var addPropsToSVG = function addPropsToSVG(IconComponent) {
  return function (_ref) {
    var className = _ref.className,
        isActive = _ref.isActive,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? 'inherit' : _ref$color,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 200 : _ref$size,
        _ref$strokeWidth = _ref.strokeWidth,
        strokeWidth = _ref$strokeWidth === void 0 ? 150 : _ref$strokeWidth,
        rest = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/_jsx(IconComponent, _objectSpread({
      className: "icon icon-ds-".concat(size, " icon-sw-").concat(strokeWidth, " icon-").concat(color, " ").concat(isActive ? 'icon-active' : '', " ").concat(className)
    }, rest));
  };
};

export default addPropsToSVG;